import { RootState } from '../../reducers';
import components from '../../selectors/components';

export const selector = (state: RootState) => components(state).authModal;
